"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const send_message_json_1 = __importDefault(require("./send-message.json"));
const onboarding_series_json_1 = __importDefault(require("./onboarding-series.json"));
// try to keep this as close to an API response payload as possible
exports.default = [
    {
        id: 0,
        title: 'New Workflow',
        description: 'Create a workflow from scratch',
        structure: [
            {
                id: 1,
                type: 'start',
                next: null,
            },
        ],
    },
    {
        id: 1,
        title: 'Send Message',
        description: 'Send a message using a manual trigger any time you need',
        structure: send_message_json_1.default,
    },
    {
        id: 2,
        title: 'Onboarding Series',
        description: 'Send a series of informative emails to help onboard your users',
        structure: onboarding_series_json_1.default,
    },
];
//# sourceMappingURL=index.js.map